import { Component, inject } from '@angular/core';
import { PermissionService } from '@core/services/permission.service';
import { ERoles } from '@enums/roles.enum';
import { EPermissions } from '@shared/enums/permissions.enum';

@Component({
  template: '',
})
export abstract class BaseComponent {
  protected readonly permissionService = inject(PermissionService);

  protected readonly EPermissions = EPermissions;
  protected readonly ERoles = ERoles;
}
